import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import produce from 'immer';
import Utils from '../../../../utils';
/**
 * @param {import('./types').RunState} state
 * @param {any} action
 */

var runContextReducer = function runContextReducer(state, action) {
  if (!action) return state;

  switch (action.type) {
    case 'SELECT_TEMPLATE':
      return produce(state, function (draft) {
        draft.selectedTemplate = action.payload;
      });

    case 'SET_TEMPLATES':
      return produce(state, function (draft) {
        draft.templates = action.payload.templates;
        draft.templatesFieldsMap = action.payload.templatesFieldsMap;
        draft.selectedTemplate = ensureSelectedTemplate(draft);
      });

    case 'HIGHLIGHT_FIELD':
      return produce(state, function (draft) {
        if (action.payload && action.payload.type !== 'page') draft.selectedField = action.payload;
        draft.selectedTemplate = getSelectedTemplate(draft, action.payload);
      });

    case 'SET_ZOOM_TITLE':
      return produce(state, function (draft) {
        draft.zoom = action.payload;
      });

    case 'STATE_CHANGED':
      return produce(state, function (draft) {
        draft.loaded = action.payload.loaded;
        draft.error = action.payload.error;
      });

    case 'SET_DATA_VERSIONS':
      return produce(state, function (draft) {
        draft.dataVersions = action.payload;
      });

    case 'SET_CURRENT_DATA_VERSION':
      return produce(state, function (draft) {
        draft.currentDataVersion = action.payload;
      });

    case 'SET_TEMPLATE_INPUT':
      return produce(state, function (draft) {
        draft.input = action.payload;
      });

    case 'SET_FORM_DATA':
      return produce(state, function (draft) {
        draft.form = _objectSpread({}, draft.form, action.payload);
      });

    case 'SET_DISCUSSION_SOURCE':
      return produce(state, function (draft) {
        draft.discussion = draft.discussion || {};
        draft.discussion.source = action.payload;
      });

    case 'SET_DISCUSSION':
      return produce(state, function (draft) {
        draft.discussion = action.payload;
      });

    case 'SET_DISCUSSION_VISIBLE':
      return produce(state, function (draft) {
        draft.discussion = draft.discussion || {};
        draft.discussion.visible = action.payload;
      });

    case 'SET_SAVING':
      return produce(state, function (draft) {
        draft.saving = action.payload;
      });

    case 'SET_VIEW':
      return produce(state, function (draft) {
        draft.view = _objectSpread({}, draft.view, action.payload);
      });

    case 'SET_PROCESSING_DATA':
      return produce(state, function (draft) {
        draft.processing = action.payload.processing;
      });

    case 'SET_REFRESHING_DATA':
      return produce(state, function (draft) {
        draft.refreshing = action.payload.refreshing;
      });
  }

  return state;
};
/**
 * @param {import('./types').RunState} state
 * @returns {string} New selected template if needed; old selected otherwise
 */


var ensureSelectedTemplate = function ensureSelectedTemplate(state) {
  if (!state.templates || !state.templates.length) return state.selectedTemplate;
  if (state.templates.includes(state.selectedTemplate)) return state.selectedTemplate;
  return state.templates[0]; // select first template
};
/**
 * @param {import('./types').RunState} state
 * @param {import('./types').TemplateField} selectedField
 * @return {string} New selected template if needed; old selected otherwise
 */


var getSelectedTemplate = function getSelectedTemplate(state, selectedField) {
  var templatesFieldsMap = state.templatesFieldsMap; // nothing to change if no field

  if (!selectedField) return state.selectedTemplate;
  if (!selectedField.name) return state.selectedTemplate; // nothing to change if no available templates

  if (!templatesFieldsMap) return state.selectedTemplate;
  var fieldName = selectedField.name,
      fieldId = selectedField.id;
  var templates = [];
  Object.keys(templatesFieldsMap).forEach(function (template) {
    if (templatesFieldsMap[template].includes(fieldName) || templatesFieldsMap[template].includes(fieldId)) templates.push(template);
  });
  if (!templates.length) return state.selectedTemplate; // in case current selected field cannot be found in current template, return the first template where we found it

  if (!templates.includes(Utils.path.getFileName(state.selectedTemplate))) {
    return state.templates.find(function (templatePath) {
      return Utils.path.getFileName(templatePath) === templates[0];
    });
  }

  return state.selectedTemplate;
};

export default runContextReducer;